import React, { useState, useEffect } from 'react';
import { Box, Switch, FormControl, Select, MenuItem, CircularProgress, Typography } from '@mui/material';

export const ActiveStatusEdit = ({ row, onChange }) => {
  const [checked, setChecked] = useState(row.original.is_active);
  
  useEffect(() => {
    setChecked(row.original.is_active);
  }, [row.original.is_active]);
  
  const handleChange = (e) => {
    const value = e.target.checked;
    setChecked(value);
    onChange(value);
  };
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Switch checked={checked} onChange={handleChange} color="success" />
      <span>{checked ? 'Yes' : 'No'}</span>
    </Box>
  );
};

export const RegionEdit = ({ row, onChange, regions, isLoading }) => {
  const currentCode = row.original.region?.code || '';
  const [value, setValue] = useState(currentCode);

  const handleChange = (e) => {
    const val = e.target.value;
    setValue(val);
    onChange(val);
  };

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1 }}>
        <CircularProgress size={16} />
        <Typography variant="body2">Loading regions...</Typography>
      </Box>
    );
  }

  return (
    <FormControl fullWidth size="small">
      <Select value={value} onChange={handleChange}>
        {regions.map((r) => (
          <MenuItem key={r.code} value={r.code}>
            {r.code} - {r.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

const normalizeTailscaleStatus = (status) => {
  if (status === 'not_active') return 'inactive';
  return status || '';
};

export const TailscaleStatusEdit = ({ row, onChange }) => {
  const cachedValue = row._valuesCache?.tailscale_approval_status;
  const originalValue = row.original.tailscale_approval_status || '';
  const currentStatus = cachedValue !== undefined ? normalizeTailscaleStatus(cachedValue || '') : normalizeTailscaleStatus(originalValue);
  const [value, setValue] = useState(currentStatus);

  useEffect(() => {
    const newCachedValue = row._valuesCache?.tailscale_approval_status;
    const newOriginalValue = row.original.tailscale_approval_status || '';
    const newStatus = newCachedValue !== undefined ? normalizeTailscaleStatus(newCachedValue || '') : normalizeTailscaleStatus(newOriginalValue);
    setValue(newStatus);
  }, [row.original.tailscale_approval_status, row._valuesCache?.tailscale_approval_status]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    onChange(newValue === '' ? null : newValue);
  };

  return (
    <FormControl fullWidth size="small">
      <Select value={value} onChange={handleChange}>
        <MenuItem value="">None</MenuItem>
        <MenuItem value="active">Active</MenuItem>
        <MenuItem value="inactive">Inactive</MenuItem>
        <MenuItem value="pending">Pending</MenuItem>
        <MenuItem value="expired">Expired</MenuItem>
      </Select>
    </FormControl>
  );
};

export const LostStatusEdit = ({ row, onChange }) => {
  const cachedValue = row._valuesCache?.is_lost;
  const originalValue = row.original.is_lost || false;
  const currentValue = cachedValue !== undefined ? cachedValue : originalValue;
  const [checked, setChecked] = useState(currentValue);
  
  useEffect(() => {
    const newCachedValue = row._valuesCache?.is_lost;
    const newOriginalValue = row.original.is_lost || false;
    const newValue = newCachedValue !== undefined ? newCachedValue : newOriginalValue;
    setChecked(newValue);
  }, [row.original.is_lost, row._valuesCache?.is_lost]);
  
  const handleChange = (e) => {
    const value = e.target.checked;
    setChecked(value);
    onChange(value);
  };
  
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Switch checked={checked} onChange={handleChange} color="error" />
      <span>{checked ? 'Yes' : 'No'}</span>
    </Box>
  );
};

export const BrokenStatusEdit = ({ row, onChange }) => {
  const cachedValue = row._valuesCache?.is_broken;
  const originalValue = row.original.is_broken || false;
  const currentValue = cachedValue !== undefined ? cachedValue : originalValue;
  const [checked, setChecked] = useState(currentValue);
  
  useEffect(() => {
    const newCachedValue = row._valuesCache?.is_broken;
    const newOriginalValue = row.original.is_broken || false;
    const newValue = newCachedValue !== undefined ? newCachedValue : newOriginalValue;
    setChecked(newValue);
  }, [row.original.is_broken, row._valuesCache?.is_broken]);
  
  const handleChange = (e) => {
    const value = e.target.checked;
    setChecked(value);
    onChange(value);
  };
  
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Switch checked={checked} onChange={handleChange} color="error" />
      <span>{checked ? 'Yes' : 'No'}</span>
    </Box>
  );
};

export const RegistrationStatusEdit = ({ row, onChange }) => {
  const cachedValue = row._valuesCache?.device_registration_status;
  const originalValue = row.original.device_registration_status || '';
  const currentStatus = cachedValue !== undefined ? (cachedValue || '') : originalValue;
  const [value, setValue] = useState(currentStatus);

  useEffect(() => {
    const newCachedValue = row._valuesCache?.device_registration_status;
    const newOriginalValue = row.original.device_registration_status || '';
    const newStatus = newCachedValue !== undefined ? (newCachedValue || '') : newOriginalValue;
    setValue(newStatus);
  }, [row.original.device_registration_status, row._valuesCache?.device_registration_status]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    onChange(newValue === '' ? null : newValue);
  };

  return (
    <FormControl fullWidth size="small">
      <Select value={value} onChange={handleChange}>
        <MenuItem value="">None</MenuItem>
        <MenuItem value="active">Active</MenuItem>
        <MenuItem value="inactive">Inactive</MenuItem>
        <MenuItem value="pending">Pending</MenuItem>
        <MenuItem value="expired">Expired</MenuItem>
      </Select>
    </FormControl>
  );
};

